import React, { useState, useEffect, useMemo } from 'react';
import { useSelector,shallowEqual ,useDispatch}      from 'react-redux';

import UserHelper from '../../common/utils/userHelper';
import { IMAGES_BASE_PATH } from '../../config/constants';
import { getImage, getVideo } from '../../utils/helper.ts';
import Video from './videoComp';
import RotatingTextSlide from "./Components/RotatingTextSlider";
interface HomeProps{
    isVideo:boolean;
    image:any;
    video:any;
    isSpeakersVisible: boolean; 
    isScheduleVisible:boolean;
    landingPageData:any,
    scheduleLabel?:string,
    speakerLabel?:string
   
}
const Home:React.FC<HomeProps> = ({isVideo,image,video,isSpeakersVisible,isScheduleVisible,landingPageData,scheduleLabel,speakerLabel}) => {
   
    const shouldShowVideo = isVideo;

    // Get image URL directly
    const imgUrl = getImage(image);

    // Build styles directly
    const containerStyles = {
        backgroundImage: !shouldShowVideo && imgUrl ? `url("${imgUrl}")` : undefined,
        backgroundSize: !shouldShowVideo && imgUrl ? 'cover' : undefined,
        backgroundPosition: !shouldShowVideo && imgUrl ? 'center' : undefined,
        backgroundRepeat: !shouldShowVideo && imgUrl ? 'no-repeat' : undefined,
        backgroundColor: !shouldShowVideo && !imgUrl ? '#f5f5f5' : undefined,
        minHeight: '100vh',
        width: '100%',
        position: 'relative',
        display: 'block',
    };

  
let videoURl = getVideo(video);

const eventData     = useSelector((state: any) => state.eventData, shallowEqual);

    
  return (
    // <!--Home section-->

<div className="single-section home-area" id="home" style={containerStyles}>

        {isVideo ? <Video videoUrl ={videoURl} /> : null}

    {/* <div className="bg"></div>
    <div className="bg bg2"></div>
    <div className="bg bg3"></div> */}
    {/* <!--home text--> */}
    <div className="container h-100">
        <div className="row h-100 align-items-center">
            <div className="col-12 col-md-12 col-lg-8 home-content">
                {/* <!--main heading--> */}
                <h1 className="main-head cd-headline clip is-full-width">
                  {landingPageData && (
                    <><span style={{color: eventData?.primary_text_color}}>{eventData?.title?.substring(0, 200)}</span><RotatingTextSlide eventData={eventData} landingPageData={landingPageData} /></>
             
                    )}
                   
                </h1>
                {/* <!--main heading ends!--> */}
                {/* <!--description--> */}
                {landingPageData && (
                <p style={{color: eventData?.primary_text_color}}  className="description"  dangerouslySetInnerHTML={{
                __html: eventData?.description?.substring(0, 500),
              }}/>
            )}
                    
                {/* <!--description ends!--> */}
                {/* <!--button area--> */}
                <div className="button-area">
                  <a className="btn scroll" href="#register" style={{color:eventData.primary_text_color , backgroundColor: eventData?.register_button_color }}>Register</a>
               
                  {isScheduleVisible &&(
                            <a className="btn scroll" href="#schedule" style={{color:eventData.primary_text_color , backgroundColor: eventData?.register_button_color }}>{scheduleLabel}</a>
            
                  )}
                    {/*isSpeakersVisible &&(
                      <a className="btn scroll" href="#speakers">{speakerLabel}</a>
                   )*/}

                
                </div>

                

                {/* <!--button area ends!--> */}
            </div>
        </div>
    </div>
    {/* <!--home text ends!--> */}
</div>
// <!--Home section ends!-->
  )
}

export default Home